import script from "./MobileVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileVersion.vue?vue&type=script&setup=true&lang=ts"

import "./MobileVersion.vue?vue&type=style&index=0&id=0bef7568&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bef7568"]])

export default __exports__